import { render, staticRenderFns } from "./PcRsNumTable.vue?vue&type=template&id=55264350&"
import script from "./PcRsNumTable.vue?vue&type=script&lang=js&"
export * from "./PcRsNumTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports